import { SafeA } from "../../components/Safe/SafeStyled";

export const FirstLoginResourcesEN: FirstLoginResourcesInterface = {
  title: "First Login Page",
  nextButton: "Forward",
  backButton: "Back",
  signatureTitle: "Signature",
  errorMissingInput: "Please fill in all fields",
  phoneNumber: {
    label: "Phone Number",
    placeholder: "Please enter phone number",
  },
  errors: {
    registerPic: "The picture you are uploading is too large.",
  },
  profilePicture: {
    label: "Profile Picture",
    name: "profilePicture",
    error: "Please select your profile picture",
    validation: "Wrong profile picture",
    description: () => (
      <>
        <h4>Drop files here or click to upload.</h4>
        <span className="text-muted font-13">Only images, max 6MB</span>
      </>
    ),
  },
  successModal: {
    title: "Data Entry",
    body: "Data addition has been successfully completed. Select OK to continue.",
    buttonOk: "OK",
  },
  errorPasswordMatch: "Passwords do not match.",
  password: {
    label: "Password",
    placeholder: "Please enter password",
  },
  passwordRepeat: {
    label: "Repeat password",
    placeholder: "Please repeat password",
  },
  termsAgreementInput: {
    name: "termsConditions",
    error: "Please accept the terms of use",
    label:
      "I accept the terms of use, privacy policy and I am familiar with other rules available in the application.",
  },
  termsAgreement: (uslovipath, politika, ostalapravila) => (
    <>
      <SafeA
        href={`${process.env.PUBLIC_URL}/pdf/` + uslovipath}
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="mdi me-2"></i>
        Terms of Use
      </SafeA>
      <SafeA
        href={`${process.env.PUBLIC_URL}/pdf/` + politika}
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="mdi me-2"></i>
        Privacy Policy
      </SafeA>
      <SafeA
        href={`${process.env.PUBLIC_URL}/pdf/` + ostalapravila}
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="mdi me-2"></i>
        Other Rules
      </SafeA>
    </>
  ),
};

interface IErrors {
  registerPic: string;
}

export interface FirstLoginResourcesInterface {
  title: string;
  nextButton: string;
  backButton: string;
  signatureTitle: string;
  errorMissingInput: string;
  phoneNumber: {
    label: string;
    placeholder: string;
  };
  profilePicture: {
    label: string;
    name: string;
    error: string;
    validation: string;
    description: () => JSX.Element;
  };
  errorPasswordMatch: string;
  password: {
    label: string;
    placeholder: string;
  };
  passwordRepeat: {
    label: string;
    placeholder: string;
  };
  successModal: {
    title: string;
    body: string;
    buttonOk: string;
  };
  termsAgreement: (
    uslovipath: string,
    politika: string,
    ostalapravila: string
  ) => JSX.Element;
  termsAgreementInput: {
    label: string;
    name: string;
    error: string;
  };
  errors: IErrors;
}
